(() => {
  "use strict";

  window.bellecour = window.bellecour || {};
  window.custom_events = window.custom_events || {}

  window.bellecour.ProductGrid = class extends HTMLElement {


    connectedCallback() {
      window.custom_events['PAGINATION_LOADED'] = 'PAGINATION_LOADED';
      this.cache = new window.bellecour.CacheManager();
      this.loading = false
      this.seeMoreButton.addEventListener("click", this.onSeeMoreClick);
      this.updateProductCountText(this.productGrid)
      this.setupInfinite();
      document.addEventListener('collection:reloaded', () => {
        this.setupInfinite()
      });
    }

    disconnectedCallback() {
      this.seeMoreButton.removeEventListener('click', this.onClickHandler);
    }

    get productGrid() {
        return document.querySelector(".product-grid");
    }

    get seeMoreButton() {
        return document.querySelector(".infinite-scroll");
    }

    get seeMoreButtonText() {
      return this.cache.get("dom", "seeMoreButtonText", () => {
        return this.seeMoreButton.querySelector('.btn-text');
      });
    }

    get pageNumber() {
      return this.productGrid.dataset.pageNumber;
    }

    get productShownCount() {
      return this.productGrid.dataset.productShownCount;
    }

    get productShownText() {
      return this.cache.get("dom", "shownProductCount", () => {
        return this.querySelector(".product-count span");
      });
    }

    get endpoint() {
      const url = new URL(this.seeMoreButton.getAttribute('action'), window.location.origin);
      url.searchParams.delete('page');

      return `${window.location.pathname}?${url.searchParams.toString()}&page=${Number(this.pageNumber) + 1}`;
    }

    onSeeMoreClick = async (event) => {
      if (this.loading) return;

      try {
        this.enableLoading()

        const response = await fetch(this.endpoint);
        if (!response.ok) throw new Error("Network response was not ok");

        const nextPageMarkup = await response.text();
        const nextPageHTML = new DOMParser().parseFromString(
          nextPageMarkup,
          "text/html"
        );
        const nextProductList = nextPageHTML.querySelector(".product-grid");

        if (!nextProductList)
          throw new Error("Could not find product list in the fetched page");

        const productHTMLList = Array.from(nextProductList.children)
          .map((child) => child.outerHTML)
          .join("");
        this.productGrid.insertAdjacentHTML("beforeend", productHTMLList);

        document.dispatchEvent(new CustomEvent(window.custom_events.PAGINATION_LOADED, {'productHtml': productHTMLList}));

        this.updateProgress(nextPageHTML);
      } catch (error) {
        console.error("Error loading more products", error);
      } finally {
          this.disableLoading()
          this.setupInfinite()
      }
    };

    updateProgress(nextPageHTML) {
      this.productGrid.dataset.pageNumber = Number(this.pageNumber) + 1;

      if (
        nextPageHTML.querySelector(".product-grid").dataset.pageNumber ===
        "last"
      ) {
        this.productGrid.dataset.pageNumber = "last";
        this.seeMoreButton.remove();
      }

      this.updateProductCountText(nextPageHTML)
    }

    updateProductCountText(pageHtml) {
      const productCount = pageHtml.querySelectorAll('.product-card--card').length
      const promotionCardCount = this.productGrid.querySelectorAll('.product-card--promo').length

      this.productGrid.dataset.promotionCardCount = promotionCardCount
      this.productGrid.dataset.productShownCount = productCount - promotionCardCount

      const seeMoreButtonTextContent = this.seeMoreButtonText.dataset.text
      this.seeMoreButtonText.innerHTML = seeMoreButtonTextContent.replace(
          "%count%",
          this.productGrid.querySelectorAll('.product-card--card').length - this.productGrid.querySelectorAll('.product-card--promo').length
      );
    }

    setupInfinite() {
      if (this.removeInView) {
        this.removeInView();
        this.removeInView = null;
      }

      if (!this.seeMoreButton) return;

      if (this.seeMoreButton.getAttribute('mode') === 'infinite') {
        this.removeInView = Motion.inView(
            this.seeMoreButton,
            this.onSeeMoreClick,
            { margin: '200px 0px 200px 0px' }
        );
      }
    }

    enableLoading() {
        this.loading = true;
    }

    disableLoading() {
        this.loading = false;
        if (this.seeMoreButton !== null) {
          this.seeMoreButton.classList.remove('pointer-events-none');
          this.seeMoreButton.removeAttribute('aria-busy');
        }
    }
  };

  if (!window.customElements.get("bellecour-product-grid")) {
    window.customElements.define(
      "bellecour-product-grid",
      window.bellecour.ProductGrid
    );
  }
})();
